import type { Frequency } from 'apiConnector/scheduledRun/model';
import { FormattedMessage } from 'react-intl';

export function FrequencyDisplay({ value, type }: Partial<Frequency>) {
  return (
    <div className="capitalize">
      {value && type ? (
        <>
          <FormattedMessage id="scheduledRun.frequency.prepend" />
          &nbsp;
          {value}&nbsp;
          <span className="text-lowercase">
            <FormattedMessage id={`scheduledRun.frequency.${type}`} />
          </span>
        </>
      ) : (
        <FormattedMessage id="scheduledRun.frequency.empty" />
      )}
    </div>
  );
}
